var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      staticStyle: { width: "100%" },
      attrs: { data: _vm.requireGoodsItemDtoList, border: "" }
    },
    [
      _c("el-table-column", { attrs: { label: "供应商", prop: "vendorName" } }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { label: "商品名称", prop: "title" } }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "合同名称", prop: "contractTitle" }
      }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { label: "数量", prop: "quantity" } }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "含税价(元)", prop: "price", align: "right" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(rows) {
              return [
                rows.row.price != null
                  ? _c("span", [_vm._v(_vm._s(rows.row.price.toFixed(2)))])
                  : _c("span", [_vm._v("0.00")])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "税率(%)", prop: "taxRate", align: "right" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(rows) {
              return [
                rows.row.taxRate != null
                  ? _c("span", [_vm._v(_vm._s(rows.row.taxRate.toFixed(2)))])
                  : _c("span", [_vm._v("0.00")])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "未税价(元)", prop: "ntxPrice", align: "right" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(rows) {
              return [
                rows.row.ntxPrice != null
                  ? _c("span", [_vm._v(_vm._s(rows.row.ntxPrice.toFixed(2)))])
                  : _c("span", [_vm._v("0.00")])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f88c4c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f88c4c5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/DeviceRequireVoucherVoucher.vue
// module id = 3126
// module chunks = 0